module.exports = __webpack_public_path__ + "media/images/default/pages/shared/testing-231b4c0ceefa2b6eabe71473bd646100.svg";